import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isBackNavigationTrigger } from '../utils/navigation';

export default function GlobalBackNavigation() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleBackClick = (event) => {
      const trigger = event.target.closest('button, a, [role="button"]');
      if (!trigger || trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;

      if (!isBackNavigationTrigger(trigger)) return;

      event.preventDefault();
      event.stopPropagation();
      navigate(-1);
    };

    document.addEventListener('click', handleBackClick, true);
    return () => document.removeEventListener('click', handleBackClick, true);
  }, [navigate]);

  return null;
}
